/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75082ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export type IAPI75082ResRecordsItemOtherDataObjMapValueObj = {};
    
  
    
export interface IAPI75082ResRecordsItemOtherDataObj {
  
  /** String */
  mapKey?: IAPI75082ResRecordsItemOtherDataObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI75082ResRecordsItemOtherDataObjMapValueObj;
  
};
    
  
    
export interface IAPI75082ResRecordsItemTreeDataItem {
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 岗位名称 */
  jobName?: string;
  
};
    
  
    
export interface IAPI75082ResRecordsItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI75082ResRecordsItemActionsItem[];
  
  /**  */
  timesTotal?: number;
  
  /**  */
  timesLeft?: number;
  
  /**  */
  isLine?: boolean;
  
  /** (该参数为map) */
  otherData?: IAPI75082ResRecordsItemOtherDataObj;
  
  /** TreeNodeResult */
  treeData?: IAPI75082ResRecordsItemTreeDataItem[];
  
};
    
  
    
export interface IAPI75082ResFromObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
  /**  */
  userId?: string;
  
};
    
  
    
export interface IAPI75082ResToObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
  /**  */
  userId?: string;
  
};
    
  



export interface API75082Req {
  
  /** 会话标识Id */
  sessionToken?: string;
  /** 会议纪要内容 */
  content?: string;
};



export interface API75082Res {
  /** 会话标识Id  */
  sessionToken?: string;
  /** 会话记录 ,ChatRecordResp  */
  records?: IAPI75082ResRecordsItem[];
  /** 用户信息 ,ChatUserResult  */
  from?: IAPI75082ResFromObj;
  /** 用户信息 ,ChatUserResult  */
  to?: IAPI75082ResToObj;
  /** 是否有聊天时间true：可以发送消息false:不可以发送  */
  hasChatTime?: boolean;
  /** 聊天时长提示true:提示，并显示兑换按钮false：不提示  */
  chatTimeTips?: boolean;
  otherData?: any;
  content?: any;
};


// 接口函数 75082 预览任务

export interface IUsePostAPI75082Return {
  /** 预览任务: 接口请求状态 */
  isAPI75082Loading: boolean;
  /** 预览任务: 接口请求返回数据 */
  dataAPI75082: API75082Res;
  /**  预览任务: 接口数据请求方法 */
  fetchAPI75082Data: (inputs: API75082Req, config?: YWRequestConfig) => Promise<API75082Res>;
  /** 预览任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75082 = ():IUsePostAPI75082Return => {
  let isMount = true;
  const [isAPI75082Loading, setIsAPI75082Loading] = useState(false);
  const [dataAPI75082, setDataAPI75082] = useState<API75082Res>({} as API75082Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/task/preview`;

  const fetchAPI75082Data = async (inputs: API75082Req, config?: YWRequestConfig): Promise<API75082Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75082Req>) || {}) as API75082Req;
    
  
    if ( isMount ) {
      setIsAPI75082Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75082Res>(`${basePath}/yoaichat-web/chat/meeting/task/preview`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75082(res || {} as API75082Res);
        setIsAPI75082Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75082Loading(false);
      }
      return false as unknown as API75082Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75082Loading,
    dataAPI75082,
    fetchAPI75082Data,
    requestUrl,
  }
}

